var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M8.5249 0L10.5962 2.30922L13.6672 1.87164L13.7696 4.972L16.4034 6.61081L14.4889 9.05161L15.4531 12L12.4176 12.6392L11.2611 15.5175L8.5249 14.056L5.78874 15.5175L4.63218 12.6392L1.5967 12L2.56091 9.05161L0.646441 6.61081L3.28025 4.972L3.3826 1.87164L6.45363 2.30922L8.5249 0Z",
    fill: "#68A14B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1499 5.375L5.8999 10.625",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.4624 6.875C6.98017 6.875 7.3999 6.45527 7.3999 5.9375C7.3999 5.41973 6.98017 5 6.4624 5C5.94464 5 5.5249 5.41973 5.5249 5.9375C5.5249 6.45527 5.94464 6.875 6.4624 6.875Z",
    fill: "#68A14B",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5874 11C11.1052 11 11.5249 10.5803 11.5249 10.0625C11.5249 9.54473 11.1052 9.125 10.5874 9.125C10.0696 9.125 9.6499 9.54473 9.6499 10.0625C9.6499 10.5803 10.0696 11 10.5874 11Z",
    fill: "#68A14B",
    stroke: "#F7F7F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.b9f330caf8f3938ecb45182f1cee5493.svg";
export { ForwardRef as ReactComponent };